
import { defineComponent, ref, inject, computed } from "vue";

const mockData = [
    { id: 1, name: "张三", date: "2026-06-25", expire_count: 8, follow_count: 6, deal_count: 1, commercial_amount: 1234, ci_amount: 4321, total_amount: 5555, deal_rate: 16.7 },
    { id: 2, name: "张三", date: "2026-06-26", expire_count: 8, follow_count: 6, deal_count: 1, commercial_amount: 1234, ci_amount: 4321, total_amount: 5555, deal_rate: 16.7 },
    { id: 3, name: "张三", date: "2026-06-27", expire_count: 8, follow_count: 6, deal_count: 1, commercial_amount: 1234, ci_amount: 4321, total_amount: 5555, deal_rate: 16.7 },
    { id: 4, name: "张三", date: "2026-06-28", expire_count: 8, follow_count: 6, deal_count: 1, commercial_amount: 1234, ci_amount: 4321, total_amount: 5555, deal_rate: 16.7 },
    { id: 5, name: "张三", date: "2026-06-29", expire_count: 8, follow_count: 6, deal_count: 1, commercial_amount: 1234, ci_amount: 4321, total_amount: 5555, deal_rate: 16.7 },
    { id: 6, name: "李四", date: "2026-06-25", expire_count: 8, follow_count: 6, deal_count: 1, commercial_amount: 1234, ci_amount: 4321, total_amount: 5555, deal_rate: 16.7 },
    { id: 7, name: "李四", date: "2026-06-26", expire_count: 8, follow_count: 6, deal_count: 1, commercial_amount: 1234, ci_amount: 4321, total_amount: 5555, deal_rate: 16.7 },
    { id: 8, name: "李四", date: "2026-06-27", expire_count: 8, follow_count: 6, deal_count: 1, commercial_amount: 1234, ci_amount: 4321, total_amount: 5555, deal_rate: 16.7 },
    { id: 9, name: "李四", date: "2026-06-28", expire_count: 8, follow_count: 6, deal_count: 1, commercial_amount: 1234, ci_amount: 4321, total_amount: 5555, deal_rate: 16.7 },
    { id: 10, name: "李四", date: "2026-06-29", expire_count: 8, follow_count: 6, deal_count: 1, commercial_amount: 1234, ci_amount: 4321, total_amount: 5555, deal_rate: 16.7 },
    { id: 11, name: "王五", date: "2026-06-25", expire_count: 8, follow_count: 6, deal_count: 1, commercial_amount: 1234, ci_amount: 4321, total_amount: 5555, deal_rate: 16.7 },
    { id: 12, name: "王五", date: "2026-06-26", expire_count: 8, follow_count: 6, deal_count: 1, commercial_amount: 1234, ci_amount: 4321, total_amount: 5555, deal_rate: 16.7 },
    { id: 13, name: "王五", date: "2026-06-27", expire_count: 8, follow_count: 6, deal_count: 1, commercial_amount: 1234, ci_amount: 4321, total_amount: 5555, deal_rate: 16.7 },
    { id: 14, name: "王五", date: "2026-06-28", expire_count: 8, follow_count: 6, deal_count: 1, commercial_amount: 1234, ci_amount: 4321, total_amount: 5555, deal_rate: 16.7 },
    { id: 15, name: "王五", date: "2026-06-29", expire_count: 8, follow_count: 6, deal_count: 1, commercial_amount: 1234, ci_amount: 4321, total_amount: 5555, deal_rate: 16.7 },
];

export default defineComponent({
    name: "Static",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["统计报表"]);

        const headClass = inject("headClass");
        const pageSize = ref(10);
        const currentPage = ref(1);
        const dateRange = ref([] as any);

        const pagedDetail = computed(() => {
            const start = (currentPage.value - 1) * pageSize.value;
            return mockData.slice(start, start + pageSize.value);
        });

        const handleSizeChange = (size: number) => {
            pageSize.value = size;
            currentPage.value = 1;
        };

        const handleCurrentChange = (page: number) => {
            currentPage.value = page;
        };

        return {
            headClass,
            pageSize,
            currentPage,
            dateRange,
            mockData,
            pagedDetail,
            handleSizeChange,
            handleCurrentChange,
        };
    },
});
